import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import ColumnsToggle from './ColumnsToggle';
import settingsIcon from '@adsk/bim360-matrix-react-assets/settings.svg';
import alloyGear from '@adsk/bim360-matrix-react-assets/alloy-gear.svg';
import { useTheme, Themes } from '@adsk/bim360-matrix-react-helpers/es/theme';
const { Places } = Tooltip;

const tooltipStyle = {
  padding: 0
};

const ActionHeaderCell = ({ container, ...rest }) => {
  const { theme } = useTheme();

  return (
    <Tooltip
      rootClose
      className="MatrixTable__settings"
      tooltipClassName="MatrixTable__settings-popover"
      container={container}
      tooltipStyle={tooltipStyle}
      place={Places.BOTTOM}
      trigger={Tooltip.TriggerEvents.CLICK}
      content={<ColumnsToggle {...rest} />}
    >
      <IconButton className="MatrixTable__settings-icon" styleType={IconButton.StyleType.MINIMAL}>
        {theme === Themes.ALLOY ? (
          <SvgIcon width="24px" height="24px">
            {alloyGear}
          </SvgIcon>
        ) : (
          <SvgIcon>{settingsIcon}</SvgIcon>
        )}
      </IconButton>
    </Tooltip>
  );
};

ActionHeaderCell.propTypes = {
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default ActionHeaderCell;
